import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  placeholder: {
    id: 'fabric.editor.captionPlaceholder',
    defaultMessage: 'Add a caption',
    description: 'Placeholder description for an empty (new) caption in the editor'
  }
});